import { render } from "./MenuLink.vue?vue&type=template&id=e24536cc&scoped=true"
import script from "./MenuLink.vue?vue&type=script&lang=js"
export * from "./MenuLink.vue?vue&type=script&lang=js"

import "./MenuLink.vue?vue&type=style&index=0&id=e24536cc&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24536cc"]])

export default __exports__